/**
 *
 * Route definition
 * Properties:
 * - legs - array with indices - first leg always dummy with startpoint only
 * - leg_#### - Leg instance
 * - distance
 */

import Leg from './Leg';
import splice from './splice';
import pointAt from './pointAt';

export default function replacePath(route, legId, travelMode) {
  const legs = route.get('legs');
  const index = legs.indexOf(legId);
  if (index < 1) {
    return route;
  }
  const startPoint = pointAt(route, index - 1);
  const endPoint = pointAt(route, index);
  const leg = new Leg([startPoint, endPoint], travelMode);
  return splice(route, index, 1, leg);
}
